module.exports = __webpack_public_path__ + "assets/img/page4-design-side-nav-collapse-2a57e532.png";